// Language translations for Treppan CRM
// Supports: English, Arabic (RTL), Spanish, French, Hindi, German, Chinese

export const translations = {
  en: {
    code: 'en',
    name: 'English',
    dir: 'ltr',
    
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      pipeline: 'Pipeline',
      contacts: 'Contacts',
      leadAssignment: 'Lead Assignment',
      realEstate: 'Real Estate',
      marketing: 'Marketing',
      socialPublishing: 'Social Publishing',
      campaigns: 'Campaigns',
      marketingAds: 'Marketing Ads',
      communication: 'Communication',
      calling: 'Calling',
      salesVisits: 'Sales Visits',
      operations: 'Operations',
      workflows: 'Workflows',
      forecast: 'Revenue Forecast',
      dataIntegration: 'Data & Integration',
      hubspotMigration: 'HubSpot Migration',
      integrations: 'Integrations',
      administration: 'Administration',
      teamManagement: 'Team Management',
      brokerMaster: 'Broker Master',
      developerMaster: 'Developer Master',
      settings: 'Settings',
      logout: 'Logout',
    },
    
    // Common
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      create: 'Create',
      update: 'Update',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      loading: 'Loading...',
      noData: 'No data available',
      success: 'Success',
      error: 'Error',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      reset: 'Reset',
      clear: 'Clear',
      apply: 'Apply',
      close: 'Close',
      view: 'View',
      download: 'Download',
      upload: 'Upload',
      import: 'Import',
      export: 'Export',
      refresh: 'Refresh',
      more: 'More',
      less: 'Less',
      all: 'All',
      none: 'None',
      yes: 'Yes',
      no: 'No',
      or: 'or',
      and: 'and',
    },
    
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      totalRevenue: 'Total Revenue',
      activeDeals: 'Active Deals',
      totalContacts: 'Total Contacts',
      winRate: 'Win Rate',
      closingThisWeek: 'closing this week',
      newThisWeek: 'new this week',
      fromLastMonth: 'from last month',
      aboveTarget: 'Above target',
      revenueTrend: 'Revenue Trend',
      activityOverview: 'Activity Overview',
      aiInsights: 'AI Insights',
      hotLeadAlert: 'Hot Lead Alert',
      dealRisk: 'Deal Risk',
      bestTimeToCall: 'Best Time to Call',
    },
    
    // Contacts
    contacts: {
      title: 'Contacts',
      createContact: 'Create contact',
      allContacts: 'All contacts',
      myContacts: 'My contacts',
      unassignedContacts: 'Unassigned contacts',
      searchPlaceholder: 'Search by name, phone, or email...',
      contactOwner: 'Contact owner',
      leadStatus: 'Lead status',
      leadScore: 'Lead Score',
      lastContacted: 'Last contacted',
      source: 'Source',
      company: 'Company',
      position: 'Position',
      phone: 'Phone',
      email: 'Email',
      address: 'Address',
      website: 'Website',
      newLead: 'New Lead',
      contacted: 'Contacted',
      qualified: 'Qualified',
      opportunity: 'Opportunity',
      customer: 'Customer',
      advanced: 'Advanced',
      clearFilters: 'Clear filters',
      noContacts: 'No contacts yet',
      createFirst: 'Create your first contact to get started',
    },
    
    // Contact Actions
    contactActions: {
      call: 'Call',
      sms: 'SMS',
      task: 'Task',
      meeting: 'Meeting',
      note: 'Note',
      sendEmail: 'Send Email',
    },
    
    // AI Features
    ai: {
      assistant: 'AI Assistant',
      askAnything: 'Ask me anything!',
      askAboutCRM: 'Ask me anything about your CRM',
      tryAsking: 'Try asking:',
      showHotLeads: 'Show me hot leads',
      dealsClosing: 'Deals closing this week',
      overdueTasks: 'Overdue tasks',
      recentActivities: 'Recent activities',
      recommendations: 'AI Recommendations',
      nextBestActions: 'Next Best Actions',
      insights: 'Insights',
      lowEngagement: 'Low Engagement',
      highPriority: 'High Priority',
      mediumPriority: 'Medium Priority',
      lowPriority: 'Low Priority',
      scheduleCall: 'Schedule follow-up call',
      sendContent: 'Send value content',
      refreshRecommendations: 'Refresh Recommendations',
    },
    
    // Settings
    settings: {
      title: 'Settings',
      profile: 'Profile',
      language: 'Language',
      selectLanguage: 'Select Language',
      languageDescription: 'Choose your preferred language for the interface',
      notifications: 'Notifications',
      security: 'Security',
      preferences: 'Preferences',
      appearance: 'Appearance',
      darkMode: 'Dark Mode',
      timezone: 'Timezone',
      dateFormat: 'Date Format',
      saveChanges: 'Save Changes',
      changesSaved: 'Changes saved successfully',
    },
    
    // Authentication
    auth: {
      login: 'Login',
      logout: 'Logout',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      forgotPassword: 'Forgot Password?',
      rememberMe: 'Remember me',
      signInWith: 'Sign in with',
      dontHaveAccount: "Don't have an account?",
      alreadyHaveAccount: 'Already have an account?',
      signUp: 'Sign up',
      signIn: 'Sign in',
    },
    
    // Deals
    deals: {
      title: 'Deals',
      pipeline: 'Pipeline',
      createDeal: 'Create Deal',
      dealValue: 'Deal Value',
      expectedClose: 'Expected Close',
      probability: 'Probability',
      stage: 'Stage',
      won: 'Won',
      lost: 'Lost',
      open: 'Open',
      analytics: 'Deal Analytics',
      forecast: 'Forecast',
    },
    
    // Tasks
    tasks: {
      title: 'Tasks',
      createTask: 'Create Task',
      dueDate: 'Due Date',
      priority: 'Priority',
      status: 'Status',
      assignedTo: 'Assigned To',
      completed: 'Completed',
      pending: 'Pending',
      overdue: 'Overdue',
      upcoming: 'Upcoming',
    },
    
    // Meetings
    meetings: {
      title: 'Meetings',
      scheduleMeeting: 'Schedule Meeting',
      startTime: 'Start Time',
      endTime: 'End Time',
      attendees: 'Attendees',
      location: 'Location',
      agenda: 'Agenda',
      scheduled: 'Scheduled',
      cancelled: 'Cancelled',
      completed: 'Completed',
    },
    
    // Time
    time: {
      today: 'Today',
      yesterday: 'Yesterday',
      tomorrow: 'Tomorrow',
      thisWeek: 'This week',
      thisMonth: 'This month',
      thisYear: 'This year',
      ago: 'ago',
      minutes: 'minutes',
      hours: 'hours',
      days: 'days',
      weeks: 'weeks',
      months: 'months',
    },
  },
  
  ar: {
    code: 'ar',
    name: 'العربية',
    dir: 'rtl',
    
    nav: {
      dashboard: 'لوحة التحكم',
      pipeline: 'خط الأنابيب',
      contacts: 'جهات الاتصال',
      leadAssignment: 'تعيين العملاء المحتملين',
      realEstate: 'العقارات',
      marketing: 'التسويق',
      socialPublishing: 'النشر الاجتماعي',
      campaigns: 'الحملات',
      marketingAds: 'إعلانات التسويق',
      communication: 'التواصل',
      calling: 'المكالمات',
      salesVisits: 'زيارات المبيعات',
      operations: 'العمليات',
      workflows: 'سير العمل',
      forecast: 'توقعات الإيرادات',
      dataIntegration: 'البيانات والتكامل',
      hubspotMigration: 'ترحيل HubSpot',
      integrations: 'التكاملات',
      administration: 'الإدارة',
      teamManagement: 'إدارة الفريق',
      brokerMaster: 'سجل الوسطاء',
      developerMaster: 'سجل المطورين',
      settings: 'الإعدادات',
      logout: 'تسجيل الخروج',
    },
    
    common: {
      save: 'حفظ',
      cancel: 'إلغاء',
      delete: 'حذف',
      edit: 'تعديل',
      add: 'إضافة',
      create: 'إنشاء',
      update: 'تحديث',
      search: 'بحث',
      filter: 'تصفية',
      sort: 'ترتيب',
      loading: 'جاري التحميل...',
      noData: 'لا توجد بيانات',
      success: 'نجاح',
      error: 'خطأ',
      confirm: 'تأكيد',
      back: 'رجوع',
      next: 'التالي',
      previous: 'السابق',
      submit: 'إرسال',
      reset: 'إعادة تعيين',
      clear: 'مسح',
      apply: 'تطبيق',
      close: 'إغلاق',
      view: 'عرض',
      download: 'تحميل',
      upload: 'رفع',
      import: 'استيراد',
      export: 'تصدير',
      refresh: 'تحديث',
      more: 'المزيد',
      less: 'أقل',
      all: 'الكل',
      none: 'لا شيء',
      yes: 'نعم',
      no: 'لا',
      or: 'أو',
      and: 'و',
    },
    
    dashboard: {
      title: 'لوحة التحكم',
      totalRevenue: 'إجمالي الإيرادات',
      activeDeals: 'الصفقات النشطة',
      totalContacts: 'إجمالي جهات الاتصال',
      winRate: 'معدل الفوز',
      closingThisWeek: 'تُغلق هذا الأسبوع',
      newThisWeek: 'جديد هذا الأسبوع',
      fromLastMonth: 'من الشهر الماضي',
      aboveTarget: 'فوق الهدف',
      revenueTrend: 'اتجاه الإيرادات',
      activityOverview: 'نظرة عامة على النشاط',
      aiInsights: 'رؤى الذكاء الاصطناعي',
      hotLeadAlert: 'تنبيه العملاء المحتملين',
      dealRisk: 'مخاطر الصفقة',
      bestTimeToCall: 'أفضل وقت للاتصال',
    },
    
    contacts: {
      title: 'جهات الاتصال',
      createContact: 'إنشاء جهة اتصال',
      allContacts: 'جميع جهات الاتصال',
      myContacts: 'جهات اتصالي',
      unassignedContacts: 'جهات اتصال غير معينة',
      searchPlaceholder: 'البحث بالاسم أو الهاتف أو البريد...',
      contactOwner: 'مالك جهة الاتصال',
      leadStatus: 'حالة العميل المحتمل',
      leadScore: 'تقييم العميل',
      lastContacted: 'آخر اتصال',
      source: 'المصدر',
      company: 'الشركة',
      position: 'المنصب',
      phone: 'الهاتف',
      email: 'البريد الإلكتروني',
      address: 'العنوان',
      website: 'الموقع الإلكتروني',
      newLead: 'عميل جديد',
      contacted: 'تم التواصل',
      qualified: 'مؤهل',
      opportunity: 'فرصة',
      customer: 'عميل',
      advanced: 'متقدم',
      clearFilters: 'مسح الفلاتر',
      noContacts: 'لا توجد جهات اتصال',
      createFirst: 'أنشئ أول جهة اتصال للبدء',
    },
    
    contactActions: {
      call: 'اتصال',
      sms: 'رسالة نصية',
      task: 'مهمة',
      meeting: 'اجتماع',
      note: 'ملاحظة',
      sendEmail: 'إرسال بريد',
    },
    
    ai: {
      assistant: 'المساعد الذكي',
      askAnything: 'اسألني أي شيء!',
      askAboutCRM: 'اسألني عن نظام إدارة العملاء',
      tryAsking: 'جرب أن تسأل:',
      showHotLeads: 'أظهر العملاء المحتملين',
      dealsClosing: 'الصفقات التي تُغلق هذا الأسبوع',
      overdueTasks: 'المهام المتأخرة',
      recentActivities: 'الأنشطة الأخيرة',
      recommendations: 'توصيات الذكاء الاصطناعي',
      nextBestActions: 'أفضل الإجراءات التالية',
      insights: 'رؤى',
      lowEngagement: 'تفاعل منخفض',
      highPriority: 'أولوية عالية',
      mediumPriority: 'أولوية متوسطة',
      lowPriority: 'أولوية منخفضة',
      scheduleCall: 'جدولة مكالمة متابعة',
      sendContent: 'إرسال محتوى قيم',
      refreshRecommendations: 'تحديث التوصيات',
    },
    
    settings: {
      title: 'الإعدادات',
      profile: 'الملف الشخصي',
      language: 'اللغة',
      selectLanguage: 'اختر اللغة',
      languageDescription: 'اختر لغتك المفضلة للواجهة',
      notifications: 'الإشعارات',
      security: 'الأمان',
      preferences: 'التفضيلات',
      appearance: 'المظهر',
      darkMode: 'الوضع الداكن',
      timezone: 'المنطقة الزمنية',
      dateFormat: 'تنسيق التاريخ',
      saveChanges: 'حفظ التغييرات',
      changesSaved: 'تم حفظ التغييرات بنجاح',
    },
    
    auth: {
      login: 'تسجيل الدخول',
      logout: 'تسجيل الخروج',
      register: 'التسجيل',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      confirmPassword: 'تأكيد كلمة المرور',
      forgotPassword: 'نسيت كلمة المرور؟',
      rememberMe: 'تذكرني',
      signInWith: 'تسجيل الدخول بواسطة',
      dontHaveAccount: 'ليس لديك حساب؟',
      alreadyHaveAccount: 'لديك حساب بالفعل؟',
      signUp: 'إنشاء حساب',
      signIn: 'تسجيل الدخول',
    },
    
    deals: {
      title: 'الصفقات',
      pipeline: 'خط الأنابيب',
      createDeal: 'إنشاء صفقة',
      dealValue: 'قيمة الصفقة',
      expectedClose: 'الإغلاق المتوقع',
      probability: 'الاحتمالية',
      stage: 'المرحلة',
      won: 'ربح',
      lost: 'خسارة',
      open: 'مفتوح',
      analytics: 'تحليلات الصفقات',
      forecast: 'التوقعات',
    },
    
    tasks: {
      title: 'المهام',
      createTask: 'إنشاء مهمة',
      dueDate: 'تاريخ الاستحقاق',
      priority: 'الأولوية',
      status: 'الحالة',
      assignedTo: 'معين إلى',
      completed: 'مكتمل',
      pending: 'قيد الانتظار',
      overdue: 'متأخر',
      upcoming: 'قادم',
    },
    
    meetings: {
      title: 'الاجتماعات',
      scheduleMeeting: 'جدولة اجتماع',
      startTime: 'وقت البدء',
      endTime: 'وقت الانتهاء',
      attendees: 'الحضور',
      location: 'الموقع',
      agenda: 'جدول الأعمال',
      scheduled: 'مجدول',
      cancelled: 'ملغى',
      completed: 'مكتمل',
    },
    
    time: {
      today: 'اليوم',
      yesterday: 'أمس',
      tomorrow: 'غداً',
      thisWeek: 'هذا الأسبوع',
      thisMonth: 'هذا الشهر',
      thisYear: 'هذا العام',
      ago: 'مضت',
      minutes: 'دقائق',
      hours: 'ساعات',
      days: 'أيام',
      weeks: 'أسابيع',
      months: 'أشهر',
    },
  },
  
  es: {
    code: 'es',
    name: 'Español',
    dir: 'ltr',
    
    nav: {
      dashboard: 'Panel de Control',
      pipeline: 'Pipeline',
      contacts: 'Contactos',
      leadAssignment: 'Asignación de Leads',
      realEstate: 'Bienes Raíces',
      marketing: 'Marketing',
      socialPublishing: 'Publicación Social',
      campaigns: 'Campañas',
      marketingAds: 'Anuncios de Marketing',
      communication: 'Comunicación',
      calling: 'Llamadas',
      salesVisits: 'Visitas de Ventas',
      operations: 'Operaciones',
      workflows: 'Flujos de Trabajo',
      forecast: 'Pronóstico de Ingresos',
      dataIntegration: 'Datos e Integración',
      hubspotMigration: 'Migración HubSpot',
      integrations: 'Integraciones',
      administration: 'Administración',
      teamManagement: 'Gestión de Equipo',
      brokerMaster: 'Maestro de Corredores',
      developerMaster: 'Maestro de Desarrolladores',
      settings: 'Configuración',
      logout: 'Cerrar Sesión',
    },
    
    common: {
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      add: 'Añadir',
      create: 'Crear',
      update: 'Actualizar',
      search: 'Buscar',
      filter: 'Filtrar',
      sort: 'Ordenar',
      loading: 'Cargando...',
      noData: 'Sin datos disponibles',
      success: 'Éxito',
      error: 'Error',
      confirm: 'Confirmar',
      back: 'Atrás',
      next: 'Siguiente',
      previous: 'Anterior',
      submit: 'Enviar',
      reset: 'Restablecer',
      clear: 'Limpiar',
      apply: 'Aplicar',
      close: 'Cerrar',
      view: 'Ver',
      download: 'Descargar',
      upload: 'Subir',
      import: 'Importar',
      export: 'Exportar',
      refresh: 'Actualizar',
      more: 'Más',
      less: 'Menos',
      all: 'Todo',
      none: 'Ninguno',
      yes: 'Sí',
      no: 'No',
      or: 'o',
      and: 'y',
    },
    
    dashboard: {
      title: 'Panel de Control',
      totalRevenue: 'Ingresos Totales',
      activeDeals: 'Negocios Activos',
      totalContacts: 'Total de Contactos',
      winRate: 'Tasa de Éxito',
      closingThisWeek: 'cerrando esta semana',
      newThisWeek: 'nuevos esta semana',
      fromLastMonth: 'del mes pasado',
      aboveTarget: 'Por encima del objetivo',
      revenueTrend: 'Tendencia de Ingresos',
      activityOverview: 'Resumen de Actividad',
      aiInsights: 'Insights de IA',
      hotLeadAlert: 'Alerta de Lead Caliente',
      dealRisk: 'Riesgo de Negocio',
      bestTimeToCall: 'Mejor Hora para Llamar',
    },
    
    contacts: {
      title: 'Contactos',
      createContact: 'Crear contacto',
      allContacts: 'Todos los contactos',
      myContacts: 'Mis contactos',
      unassignedContacts: 'Contactos sin asignar',
      searchPlaceholder: 'Buscar por nombre, teléfono o email...',
      contactOwner: 'Propietario del contacto',
      leadStatus: 'Estado del lead',
      leadScore: 'Puntuación del Lead',
      lastContacted: 'Último contacto',
      source: 'Fuente',
      company: 'Empresa',
      position: 'Cargo',
      phone: 'Teléfono',
      email: 'Correo electrónico',
      address: 'Dirección',
      website: 'Sitio web',
      newLead: 'Nuevo Lead',
      contacted: 'Contactado',
      qualified: 'Calificado',
      opportunity: 'Oportunidad',
      customer: 'Cliente',
      advanced: 'Avanzado',
      clearFilters: 'Limpiar filtros',
      noContacts: 'Sin contactos',
      createFirst: 'Crea tu primer contacto para comenzar',
    },
    
    contactActions: {
      call: 'Llamar',
      sms: 'SMS',
      task: 'Tarea',
      meeting: 'Reunión',
      note: 'Nota',
      sendEmail: 'Enviar Email',
    },
    
    ai: {
      assistant: 'Asistente IA',
      askAnything: '¡Pregúntame lo que quieras!',
      askAboutCRM: 'Pregúntame sobre tu CRM',
      tryAsking: 'Intenta preguntar:',
      showHotLeads: 'Muéstrame leads calientes',
      dealsClosing: 'Negocios cerrando esta semana',
      overdueTasks: 'Tareas vencidas',
      recentActivities: 'Actividades recientes',
      recommendations: 'Recomendaciones de IA',
      nextBestActions: 'Mejores Acciones Siguientes',
      insights: 'Insights',
      lowEngagement: 'Bajo Engagement',
      highPriority: 'Alta Prioridad',
      mediumPriority: 'Prioridad Media',
      lowPriority: 'Baja Prioridad',
      scheduleCall: 'Programar llamada de seguimiento',
      sendContent: 'Enviar contenido de valor',
      refreshRecommendations: 'Actualizar Recomendaciones',
    },
    
    settings: {
      title: 'Configuración',
      profile: 'Perfil',
      language: 'Idioma',
      selectLanguage: 'Seleccionar Idioma',
      languageDescription: 'Elige tu idioma preferido para la interfaz',
      notifications: 'Notificaciones',
      security: 'Seguridad',
      preferences: 'Preferencias',
      appearance: 'Apariencia',
      darkMode: 'Modo Oscuro',
      timezone: 'Zona Horaria',
      dateFormat: 'Formato de Fecha',
      saveChanges: 'Guardar Cambios',
      changesSaved: 'Cambios guardados exitosamente',
    },
    
    auth: {
      login: 'Iniciar Sesión',
      logout: 'Cerrar Sesión',
      register: 'Registrarse',
      email: 'Correo electrónico',
      password: 'Contraseña',
      confirmPassword: 'Confirmar Contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?',
      rememberMe: 'Recordarme',
      signInWith: 'Iniciar sesión con',
      dontHaveAccount: '¿No tienes cuenta?',
      alreadyHaveAccount: '¿Ya tienes cuenta?',
      signUp: 'Registrarse',
      signIn: 'Iniciar sesión',
    },
    
    deals: {
      title: 'Negocios',
      pipeline: 'Pipeline',
      createDeal: 'Crear Negocio',
      dealValue: 'Valor del Negocio',
      expectedClose: 'Cierre Esperado',
      probability: 'Probabilidad',
      stage: 'Etapa',
      won: 'Ganado',
      lost: 'Perdido',
      open: 'Abierto',
      analytics: 'Análisis de Negocios',
      forecast: 'Pronóstico',
    },
    
    tasks: {
      title: 'Tareas',
      createTask: 'Crear Tarea',
      dueDate: 'Fecha de Vencimiento',
      priority: 'Prioridad',
      status: 'Estado',
      assignedTo: 'Asignado a',
      completed: 'Completado',
      pending: 'Pendiente',
      overdue: 'Vencido',
      upcoming: 'Próximo',
    },
    
    meetings: {
      title: 'Reuniones',
      scheduleMeeting: 'Programar Reunión',
      startTime: 'Hora de Inicio',
      endTime: 'Hora de Fin',
      attendees: 'Asistentes',
      location: 'Ubicación',
      agenda: 'Agenda',
      scheduled: 'Programado',
      cancelled: 'Cancelado',
      completed: 'Completado',
    },
    
    time: {
      today: 'Hoy',
      yesterday: 'Ayer',
      tomorrow: 'Mañana',
      thisWeek: 'Esta semana',
      thisMonth: 'Este mes',
      thisYear: 'Este año',
      ago: 'hace',
      minutes: 'minutos',
      hours: 'horas',
      days: 'días',
      weeks: 'semanas',
      months: 'meses',
    },
  },
  
  fr: {
    code: 'fr',
    name: 'Français',
    dir: 'ltr',
    
    nav: {
      dashboard: 'Tableau de Bord',
      pipeline: 'Pipeline',
      contacts: 'Contacts',
      leadAssignment: 'Attribution des Leads',
      realEstate: 'Immobilier',
      marketing: 'Marketing',
      socialPublishing: 'Publication Sociale',
      campaigns: 'Campagnes',
      marketingAds: 'Publicités Marketing',
      communication: 'Communication',
      calling: 'Appels',
      salesVisits: 'Visites Commerciales',
      operations: 'Opérations',
      workflows: 'Flux de Travail',
      forecast: 'Prévisions de Revenus',
      dataIntegration: 'Données et Intégration',
      hubspotMigration: 'Migration HubSpot',
      integrations: 'Intégrations',
      administration: 'Administration',
      teamManagement: 'Gestion d\'Équipe',
      brokerMaster: 'Maître des Courtiers',
      developerMaster: 'Maître des Développeurs',
      settings: 'Paramètres',
      logout: 'Déconnexion',
    },
    
    common: {
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      add: 'Ajouter',
      create: 'Créer',
      update: 'Mettre à jour',
      search: 'Rechercher',
      filter: 'Filtrer',
      sort: 'Trier',
      loading: 'Chargement...',
      noData: 'Aucune donnée disponible',
      success: 'Succès',
      error: 'Erreur',
      confirm: 'Confirmer',
      back: 'Retour',
      next: 'Suivant',
      previous: 'Précédent',
      submit: 'Soumettre',
      reset: 'Réinitialiser',
      clear: 'Effacer',
      apply: 'Appliquer',
      close: 'Fermer',
      view: 'Voir',
      download: 'Télécharger',
      upload: 'Téléverser',
      import: 'Importer',
      export: 'Exporter',
      refresh: 'Actualiser',
      more: 'Plus',
      less: 'Moins',
      all: 'Tout',
      none: 'Aucun',
      yes: 'Oui',
      no: 'Non',
      or: 'ou',
      and: 'et',
    },
    
    dashboard: {
      title: 'Tableau de Bord',
      totalRevenue: 'Revenus Totaux',
      activeDeals: 'Affaires Actives',
      totalContacts: 'Total des Contacts',
      winRate: 'Taux de Réussite',
      closingThisWeek: 'clôture cette semaine',
      newThisWeek: 'nouveaux cette semaine',
      fromLastMonth: 'du mois dernier',
      aboveTarget: 'Au-dessus de l\'objectif',
      revenueTrend: 'Tendance des Revenus',
      activityOverview: 'Aperçu des Activités',
      aiInsights: 'Insights IA',
      hotLeadAlert: 'Alerte Lead Chaud',
      dealRisk: 'Risque d\'Affaire',
      bestTimeToCall: 'Meilleur Moment pour Appeler',
    },
    
    contacts: {
      title: 'Contacts',
      createContact: 'Créer un contact',
      allContacts: 'Tous les contacts',
      myContacts: 'Mes contacts',
      unassignedContacts: 'Contacts non assignés',
      searchPlaceholder: 'Rechercher par nom, téléphone ou email...',
      contactOwner: 'Propriétaire du contact',
      leadStatus: 'Statut du lead',
      leadScore: 'Score du Lead',
      lastContacted: 'Dernier contact',
      source: 'Source',
      company: 'Entreprise',
      position: 'Poste',
      phone: 'Téléphone',
      email: 'Email',
      address: 'Adresse',
      website: 'Site web',
      newLead: 'Nouveau Lead',
      contacted: 'Contacté',
      qualified: 'Qualifié',
      opportunity: 'Opportunité',
      customer: 'Client',
      advanced: 'Avancé',
      clearFilters: 'Effacer les filtres',
      noContacts: 'Aucun contact',
      createFirst: 'Créez votre premier contact pour commencer',
    },
    
    contactActions: {
      call: 'Appeler',
      sms: 'SMS',
      task: 'Tâche',
      meeting: 'Réunion',
      note: 'Note',
      sendEmail: 'Envoyer Email',
    },
    
    ai: {
      assistant: 'Assistant IA',
      askAnything: 'Demandez-moi n\'importe quoi!',
      askAboutCRM: 'Posez-moi des questions sur votre CRM',
      tryAsking: 'Essayez de demander:',
      showHotLeads: 'Montrez-moi les leads chauds',
      dealsClosing: 'Affaires clôturant cette semaine',
      overdueTasks: 'Tâches en retard',
      recentActivities: 'Activités récentes',
      recommendations: 'Recommandations IA',
      nextBestActions: 'Meilleures Actions Suivantes',
      insights: 'Insights',
      lowEngagement: 'Faible Engagement',
      highPriority: 'Haute Priorité',
      mediumPriority: 'Priorité Moyenne',
      lowPriority: 'Basse Priorité',
      scheduleCall: 'Planifier un appel de suivi',
      sendContent: 'Envoyer du contenu de valeur',
      refreshRecommendations: 'Actualiser les Recommandations',
    },
    
    settings: {
      title: 'Paramètres',
      profile: 'Profil',
      language: 'Langue',
      selectLanguage: 'Sélectionner la Langue',
      languageDescription: 'Choisissez votre langue préférée pour l\'interface',
      notifications: 'Notifications',
      security: 'Sécurité',
      preferences: 'Préférences',
      appearance: 'Apparence',
      darkMode: 'Mode Sombre',
      timezone: 'Fuseau Horaire',
      dateFormat: 'Format de Date',
      saveChanges: 'Enregistrer les Modifications',
      changesSaved: 'Modifications enregistrées avec succès',
    },
    
    auth: {
      login: 'Connexion',
      logout: 'Déconnexion',
      register: 'S\'inscrire',
      email: 'Email',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      forgotPassword: 'Mot de passe oublié?',
      rememberMe: 'Se souvenir de moi',
      signInWith: 'Se connecter avec',
      dontHaveAccount: 'Pas de compte?',
      alreadyHaveAccount: 'Déjà un compte?',
      signUp: 'S\'inscrire',
      signIn: 'Se connecter',
    },
    
    deals: {
      title: 'Affaires',
      pipeline: 'Pipeline',
      createDeal: 'Créer une Affaire',
      dealValue: 'Valeur de l\'Affaire',
      expectedClose: 'Clôture Prévue',
      probability: 'Probabilité',
      stage: 'Étape',
      won: 'Gagné',
      lost: 'Perdu',
      open: 'Ouvert',
      analytics: 'Analyse des Affaires',
      forecast: 'Prévisions',
    },
    
    tasks: {
      title: 'Tâches',
      createTask: 'Créer une Tâche',
      dueDate: 'Date d\'Échéance',
      priority: 'Priorité',
      status: 'Statut',
      assignedTo: 'Assigné à',
      completed: 'Terminé',
      pending: 'En Attente',
      overdue: 'En Retard',
      upcoming: 'À Venir',
    },
    
    meetings: {
      title: 'Réunions',
      scheduleMeeting: 'Planifier une Réunion',
      startTime: 'Heure de Début',
      endTime: 'Heure de Fin',
      attendees: 'Participants',
      location: 'Lieu',
      agenda: 'Ordre du Jour',
      scheduled: 'Planifié',
      cancelled: 'Annulé',
      completed: 'Terminé',
    },
    
    time: {
      today: 'Aujourd\'hui',
      yesterday: 'Hier',
      tomorrow: 'Demain',
      thisWeek: 'Cette semaine',
      thisMonth: 'Ce mois',
      thisYear: 'Cette année',
      ago: 'il y a',
      minutes: 'minutes',
      hours: 'heures',
      days: 'jours',
      weeks: 'semaines',
      months: 'mois',
    },
  },
  
  hi: {
    code: 'hi',
    name: 'हिंदी',
    dir: 'ltr',
    
    nav: {
      dashboard: 'डैशबोर्ड',
      pipeline: 'पाइपलाइन',
      contacts: 'संपर्क',
      leadAssignment: 'लीड असाइनमेंट',
      realEstate: 'रियल एस्टेट',
      marketing: 'मार्केटिंग',
      socialPublishing: 'सोशल प्रकाशन',
      campaigns: 'अभियान',
      marketingAds: 'मार्केटिंग विज्ञापन',
      communication: 'संचार',
      calling: 'कॉलिंग',
      salesVisits: 'सेल्स विज़िट',
      operations: 'संचालन',
      workflows: 'वर्कफ़्लो',
      forecast: 'राजस्व पूर्वानुमान',
      dataIntegration: 'डेटा और एकीकरण',
      hubspotMigration: 'HubSpot माइग्रेशन',
      integrations: 'एकीकरण',
      administration: 'प्रशासन',
      teamManagement: 'टीम प्रबंधन',
      brokerMaster: 'ब्रोकर मास्टर',
      developerMaster: 'डेवलपर मास्टर',
      settings: 'सेटिंग्स',
      logout: 'लॉग आउट',
    },
    
    common: {
      save: 'सहेजें',
      cancel: 'रद्द करें',
      delete: 'हटाएं',
      edit: 'संपादित करें',
      add: 'जोड़ें',
      create: 'बनाएं',
      update: 'अपडेट करें',
      search: 'खोजें',
      filter: 'फ़िल्टर',
      sort: 'क्रमबद्ध करें',
      loading: 'लोड हो रहा है...',
      noData: 'कोई डेटा उपलब्ध नहीं',
      success: 'सफलता',
      error: 'त्रुटि',
      confirm: 'पुष्टि करें',
      back: 'वापस',
      next: 'अगला',
      previous: 'पिछला',
      submit: 'जमा करें',
      reset: 'रीसेट',
      clear: 'साफ़ करें',
      apply: 'लागू करें',
      close: 'बंद करें',
      view: 'देखें',
      download: 'डाउनलोड',
      upload: 'अपलोड',
      import: 'आयात',
      export: 'निर्यात',
      refresh: 'रिफ्रेश',
      more: 'अधिक',
      less: 'कम',
      all: 'सभी',
      none: 'कोई नहीं',
      yes: 'हाँ',
      no: 'नहीं',
      or: 'या',
      and: 'और',
    },
    
    dashboard: {
      title: 'डैशबोर्ड',
      totalRevenue: 'कुल राजस्व',
      activeDeals: 'सक्रिय सौदे',
      totalContacts: 'कुल संपर्क',
      winRate: 'जीत दर',
      closingThisWeek: 'इस सप्ताह बंद हो रहे',
      newThisWeek: 'इस सप्ताह नए',
      fromLastMonth: 'पिछले महीने से',
      aboveTarget: 'लक्ष्य से ऊपर',
      revenueTrend: 'राजस्व प्रवृत्ति',
      activityOverview: 'गतिविधि अवलोकन',
      aiInsights: 'AI इनसाइट्स',
      hotLeadAlert: 'हॉट लीड अलर्ट',
      dealRisk: 'डील जोखिम',
      bestTimeToCall: 'कॉल करने का सबसे अच्छा समय',
    },
    
    contacts: {
      title: 'संपर्क',
      createContact: 'संपर्क बनाएं',
      allContacts: 'सभी संपर्क',
      myContacts: 'मेरे संपर्क',
      unassignedContacts: 'असाइन नहीं किए गए संपर्क',
      searchPlaceholder: 'नाम, फोन या ईमेल से खोजें...',
      contactOwner: 'संपर्क मालिक',
      leadStatus: 'लीड स्थिति',
      leadScore: 'लीड स्कोर',
      lastContacted: 'अंतिम संपर्क',
      source: 'स्रोत',
      company: 'कंपनी',
      position: 'पद',
      phone: 'फोन',
      email: 'ईमेल',
      address: 'पता',
      website: 'वेबसाइट',
      newLead: 'नई लीड',
      contacted: 'संपर्क किया',
      qualified: 'योग्य',
      opportunity: 'अवसर',
      customer: 'ग्राहक',
      advanced: 'उन्नत',
      clearFilters: 'फ़िल्टर साफ़ करें',
      noContacts: 'कोई संपर्क नहीं',
      createFirst: 'शुरू करने के लिए अपना पहला संपर्क बनाएं',
    },
    
    contactActions: {
      call: 'कॉल',
      sms: 'एसएमएस',
      task: 'कार्य',
      meeting: 'बैठक',
      note: 'नोट',
      sendEmail: 'ईमेल भेजें',
    },
    
    ai: {
      assistant: 'AI सहायक',
      askAnything: 'मुझसे कुछ भी पूछें!',
      askAboutCRM: 'अपने CRM के बारे में पूछें',
      tryAsking: 'पूछने की कोशिश करें:',
      showHotLeads: 'हॉट लीड्स दिखाएं',
      dealsClosing: 'इस सप्ताह बंद होने वाले सौदे',
      overdueTasks: 'देरी से कार्य',
      recentActivities: 'हाल की गतिविधियां',
      recommendations: 'AI सिफारिशें',
      nextBestActions: 'अगली सर्वश्रेष्ठ कार्रवाइयां',
      insights: 'इनसाइट्स',
      lowEngagement: 'कम जुड़ाव',
      highPriority: 'उच्च प्राथमिकता',
      mediumPriority: 'मध्यम प्राथमिकता',
      lowPriority: 'कम प्राथमिकता',
      scheduleCall: 'फॉलो-अप कॉल शेड्यूल करें',
      sendContent: 'मूल्यवान सामग्री भेजें',
      refreshRecommendations: 'सिफारिशें रिफ्रेश करें',
    },
    
    settings: {
      title: 'सेटिंग्स',
      profile: 'प्रोफाइल',
      language: 'भाषा',
      selectLanguage: 'भाषा चुनें',
      languageDescription: 'इंटरफ़ेस के लिए अपनी पसंदीदा भाषा चुनें',
      notifications: 'सूचनाएं',
      security: 'सुरक्षा',
      preferences: 'प्राथमिकताएं',
      appearance: 'दिखावट',
      darkMode: 'डार्क मोड',
      timezone: 'समय क्षेत्र',
      dateFormat: 'तारीख प्रारूप',
      saveChanges: 'परिवर्तन सहेजें',
      changesSaved: 'परिवर्तन सफलतापूर्वक सहेजे गए',
    },
    
    auth: {
      login: 'लॉग इन',
      logout: 'लॉग आउट',
      register: 'पंजीकरण',
      email: 'ईमेल',
      password: 'पासवर्ड',
      confirmPassword: 'पासवर्ड की पुष्टि करें',
      forgotPassword: 'पासवर्ड भूल गए?',
      rememberMe: 'मुझे याद रखें',
      signInWith: 'साइन इन करें',
      dontHaveAccount: 'खाता नहीं है?',
      alreadyHaveAccount: 'पहले से खाता है?',
      signUp: 'साइन अप',
      signIn: 'साइन इन',
    },
    
    deals: {
      title: 'सौदे',
      pipeline: 'पाइपलाइन',
      createDeal: 'सौदा बनाएं',
      dealValue: 'सौदे का मूल्य',
      expectedClose: 'अपेक्षित समापन',
      probability: 'संभावना',
      stage: 'चरण',
      won: 'जीता',
      lost: 'हारा',
      open: 'खुला',
      analytics: 'सौदे विश्लेषण',
      forecast: 'पूर्वानुमान',
    },
    
    tasks: {
      title: 'कार्य',
      createTask: 'कार्य बनाएं',
      dueDate: 'नियत तिथि',
      priority: 'प्राथमिकता',
      status: 'स्थिति',
      assignedTo: 'को सौंपा गया',
      completed: 'पूर्ण',
      pending: 'लंबित',
      overdue: 'देरी से',
      upcoming: 'आगामी',
    },
    
    meetings: {
      title: 'बैठकें',
      scheduleMeeting: 'बैठक शेड्यूल करें',
      startTime: 'शुरू का समय',
      endTime: 'समाप्ति का समय',
      attendees: 'उपस्थित लोग',
      location: 'स्थान',
      agenda: 'एजेंडा',
      scheduled: 'शेड्यूल किया गया',
      cancelled: 'रद्द',
      completed: 'पूर्ण',
    },
    
    time: {
      today: 'आज',
      yesterday: 'कल',
      tomorrow: 'कल',
      thisWeek: 'इस सप्ताह',
      thisMonth: 'इस महीने',
      thisYear: 'इस वर्ष',
      ago: 'पहले',
      minutes: 'मिनट',
      hours: 'घंटे',
      days: 'दिन',
      weeks: 'सप्ताह',
      months: 'महीने',
    },
  },
  
  de: {
    code: 'de',
    name: 'Deutsch',
    dir: 'ltr',
    
    nav: {
      dashboard: 'Dashboard',
      pipeline: 'Pipeline',
      contacts: 'Kontakte',
      leadAssignment: 'Lead-Zuweisung',
      realEstate: 'Immobilien',
      marketing: 'Marketing',
      socialPublishing: 'Social Publishing',
      campaigns: 'Kampagnen',
      marketingAds: 'Marketing-Anzeigen',
      communication: 'Kommunikation',
      calling: 'Anrufe',
      salesVisits: 'Verkaufsbesuche',
      operations: 'Betrieb',
      workflows: 'Workflows',
      forecast: 'Umsatzprognose',
      dataIntegration: 'Daten & Integration',
      hubspotMigration: 'HubSpot-Migration',
      integrations: 'Integrationen',
      administration: 'Verwaltung',
      teamManagement: 'Team-Management',
      brokerMaster: 'Makler-Stammdaten',
      developerMaster: 'Entwickler-Stammdaten',
      settings: 'Einstellungen',
      logout: 'Abmelden',
    },
    
    common: {
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      add: 'Hinzufügen',
      create: 'Erstellen',
      update: 'Aktualisieren',
      search: 'Suchen',
      filter: 'Filtern',
      sort: 'Sortieren',
      loading: 'Laden...',
      noData: 'Keine Daten verfügbar',
      success: 'Erfolg',
      error: 'Fehler',
      confirm: 'Bestätigen',
      back: 'Zurück',
      next: 'Weiter',
      previous: 'Zurück',
      submit: 'Absenden',
      reset: 'Zurücksetzen',
      clear: 'Leeren',
      apply: 'Anwenden',
      close: 'Schließen',
      view: 'Ansehen',
      download: 'Herunterladen',
      upload: 'Hochladen',
      import: 'Importieren',
      export: 'Exportieren',
      refresh: 'Aktualisieren',
      more: 'Mehr',
      less: 'Weniger',
      all: 'Alle',
      none: 'Keine',
      yes: 'Ja',
      no: 'Nein',
      or: 'oder',
      and: 'und',
    },
    
    dashboard: {
      title: 'Dashboard',
      totalRevenue: 'Gesamtumsatz',
      activeDeals: 'Aktive Deals',
      totalContacts: 'Kontakte gesamt',
      winRate: 'Gewinnrate',
      closingThisWeek: 'schließen diese Woche',
      newThisWeek: 'neu diese Woche',
      fromLastMonth: 'vom letzten Monat',
      aboveTarget: 'Über dem Ziel',
      revenueTrend: 'Umsatztrend',
      activityOverview: 'Aktivitätsübersicht',
      aiInsights: 'KI-Insights',
      hotLeadAlert: 'Hot Lead Alarm',
      dealRisk: 'Deal-Risiko',
      bestTimeToCall: 'Beste Zeit zum Anrufen',
    },
    
    contacts: {
      title: 'Kontakte',
      createContact: 'Kontakt erstellen',
      allContacts: 'Alle Kontakte',
      myContacts: 'Meine Kontakte',
      unassignedContacts: 'Nicht zugewiesene Kontakte',
      searchPlaceholder: 'Nach Name, Telefon oder E-Mail suchen...',
      contactOwner: 'Kontaktinhaber',
      leadStatus: 'Lead-Status',
      leadScore: 'Lead-Score',
      lastContacted: 'Letzter Kontakt',
      source: 'Quelle',
      company: 'Unternehmen',
      position: 'Position',
      phone: 'Telefon',
      email: 'E-Mail',
      address: 'Adresse',
      website: 'Website',
      newLead: 'Neuer Lead',
      contacted: 'Kontaktiert',
      qualified: 'Qualifiziert',
      opportunity: 'Opportunity',
      customer: 'Kunde',
      advanced: 'Erweitert',
      clearFilters: 'Filter löschen',
      noContacts: 'Keine Kontakte',
      createFirst: 'Erstellen Sie Ihren ersten Kontakt',
    },
    
    contactActions: {
      call: 'Anrufen',
      sms: 'SMS',
      task: 'Aufgabe',
      meeting: 'Meeting',
      note: 'Notiz',
      sendEmail: 'E-Mail senden',
    },
    
    ai: {
      assistant: 'KI-Assistent',
      askAnything: 'Fragen Sie mich alles!',
      askAboutCRM: 'Fragen Sie mich über Ihr CRM',
      tryAsking: 'Versuchen Sie zu fragen:',
      showHotLeads: 'Zeigen Sie mir Hot Leads',
      dealsClosing: 'Deals, die diese Woche schließen',
      overdueTasks: 'Überfällige Aufgaben',
      recentActivities: 'Aktuelle Aktivitäten',
      recommendations: 'KI-Empfehlungen',
      nextBestActions: 'Nächste beste Aktionen',
      insights: 'Insights',
      lowEngagement: 'Niedriges Engagement',
      highPriority: 'Hohe Priorität',
      mediumPriority: 'Mittlere Priorität',
      lowPriority: 'Niedrige Priorität',
      scheduleCall: 'Follow-up-Anruf planen',
      sendContent: 'Wertvolle Inhalte senden',
      refreshRecommendations: 'Empfehlungen aktualisieren',
    },
    
    settings: {
      title: 'Einstellungen',
      profile: 'Profil',
      language: 'Sprache',
      selectLanguage: 'Sprache auswählen',
      languageDescription: 'Wählen Sie Ihre bevorzugte Sprache für die Oberfläche',
      notifications: 'Benachrichtigungen',
      security: 'Sicherheit',
      preferences: 'Einstellungen',
      appearance: 'Aussehen',
      darkMode: 'Dunkelmodus',
      timezone: 'Zeitzone',
      dateFormat: 'Datumsformat',
      saveChanges: 'Änderungen speichern',
      changesSaved: 'Änderungen erfolgreich gespeichert',
    },
    
    auth: {
      login: 'Anmelden',
      logout: 'Abmelden',
      register: 'Registrieren',
      email: 'E-Mail',
      password: 'Passwort',
      confirmPassword: 'Passwort bestätigen',
      forgotPassword: 'Passwort vergessen?',
      rememberMe: 'Angemeldet bleiben',
      signInWith: 'Anmelden mit',
      dontHaveAccount: 'Kein Konto?',
      alreadyHaveAccount: 'Bereits ein Konto?',
      signUp: 'Registrieren',
      signIn: 'Anmelden',
    },
    
    deals: {
      title: 'Deals',
      pipeline: 'Pipeline',
      createDeal: 'Deal erstellen',
      dealValue: 'Deal-Wert',
      expectedClose: 'Erwarteter Abschluss',
      probability: 'Wahrscheinlichkeit',
      stage: 'Phase',
      won: 'Gewonnen',
      lost: 'Verloren',
      open: 'Offen',
      analytics: 'Deal-Analyse',
      forecast: 'Prognose',
    },
    
    tasks: {
      title: 'Aufgaben',
      createTask: 'Aufgabe erstellen',
      dueDate: 'Fälligkeitsdatum',
      priority: 'Priorität',
      status: 'Status',
      assignedTo: 'Zugewiesen an',
      completed: 'Abgeschlossen',
      pending: 'Ausstehend',
      overdue: 'Überfällig',
      upcoming: 'Bevorstehend',
    },
    
    meetings: {
      title: 'Meetings',
      scheduleMeeting: 'Meeting planen',
      startTime: 'Startzeit',
      endTime: 'Endzeit',
      attendees: 'Teilnehmer',
      location: 'Ort',
      agenda: 'Agenda',
      scheduled: 'Geplant',
      cancelled: 'Abgesagt',
      completed: 'Abgeschlossen',
    },
    
    time: {
      today: 'Heute',
      yesterday: 'Gestern',
      tomorrow: 'Morgen',
      thisWeek: 'Diese Woche',
      thisMonth: 'Diesen Monat',
      thisYear: 'Dieses Jahr',
      ago: 'vor',
      minutes: 'Minuten',
      hours: 'Stunden',
      days: 'Tagen',
      weeks: 'Wochen',
      months: 'Monaten',
    },
  },
  
  zh: {
    code: 'zh',
    name: '中文',
    dir: 'ltr',
    
    nav: {
      dashboard: '仪表板',
      pipeline: '销售管道',
      contacts: '联系人',
      leadAssignment: '线索分配',
      realEstate: '房地产',
      marketing: '营销',
      socialPublishing: '社交发布',
      campaigns: '活动',
      marketingAds: '营销广告',
      communication: '沟通',
      calling: '通话',
      salesVisits: '销售拜访',
      operations: '运营',
      workflows: '工作流程',
      forecast: '收入预测',
      dataIntegration: '数据与集成',
      hubspotMigration: 'HubSpot迁移',
      integrations: '集成',
      administration: '管理',
      teamManagement: '团队管理',
      brokerMaster: '经纪人主数据',
      developerMaster: '开发商主数据',
      settings: '设置',
      logout: '退出登录',
    },
    
    common: {
      save: '保存',
      cancel: '取消',
      delete: '删除',
      edit: '编辑',
      add: '添加',
      create: '创建',
      update: '更新',
      search: '搜索',
      filter: '筛选',
      sort: '排序',
      loading: '加载中...',
      noData: '暂无数据',
      success: '成功',
      error: '错误',
      confirm: '确认',
      back: '返回',
      next: '下一步',
      previous: '上一步',
      submit: '提交',
      reset: '重置',
      clear: '清除',
      apply: '应用',
      close: '关闭',
      view: '查看',
      download: '下载',
      upload: '上传',
      import: '导入',
      export: '导出',
      refresh: '刷新',
      more: '更多',
      less: '收起',
      all: '全部',
      none: '无',
      yes: '是',
      no: '否',
      or: '或',
      and: '和',
    },
    
    dashboard: {
      title: '仪表板',
      totalRevenue: '总收入',
      activeDeals: '活跃交易',
      totalContacts: '联系人总数',
      winRate: '赢单率',
      closingThisWeek: '本周成交',
      newThisWeek: '本周新增',
      fromLastMonth: '较上月',
      aboveTarget: '超额完成',
      revenueTrend: '收入趋势',
      activityOverview: '活动概览',
      aiInsights: 'AI洞察',
      hotLeadAlert: '热门线索提醒',
      dealRisk: '交易风险',
      bestTimeToCall: '最佳通话时间',
    },
    
    contacts: {
      title: '联系人',
      createContact: '创建联系人',
      allContacts: '全部联系人',
      myContacts: '我的联系人',
      unassignedContacts: '未分配联系人',
      searchPlaceholder: '按姓名、电话或邮箱搜索...',
      contactOwner: '联系人负责人',
      leadStatus: '线索状态',
      leadScore: '线索评分',
      lastContacted: '最后联系',
      source: '来源',
      company: '公司',
      position: '职位',
      phone: '电话',
      email: '邮箱',
      address: '地址',
      website: '网站',
      newLead: '新线索',
      contacted: '已联系',
      qualified: '已验证',
      opportunity: '商机',
      customer: '客户',
      advanced: '高级',
      clearFilters: '清除筛选',
      noContacts: '暂无联系人',
      createFirst: '创建您的第一个联系人',
    },
    
    contactActions: {
      call: '通话',
      sms: '短信',
      task: '任务',
      meeting: '会议',
      note: '备注',
      sendEmail: '发送邮件',
    },
    
    ai: {
      assistant: 'AI助手',
      askAnything: '问我任何问题！',
      askAboutCRM: '询问关于您的CRM',
      tryAsking: '试着问：',
      showHotLeads: '显示热门线索',
      dealsClosing: '本周成交的交易',
      overdueTasks: '逾期任务',
      recentActivities: '最近活动',
      recommendations: 'AI建议',
      nextBestActions: '下一步最佳行动',
      insights: '洞察',
      lowEngagement: '低互动',
      highPriority: '高优先级',
      mediumPriority: '中优先级',
      lowPriority: '低优先级',
      scheduleCall: '安排跟进电话',
      sendContent: '发送有价值内容',
      refreshRecommendations: '刷新建议',
    },
    
    settings: {
      title: '设置',
      profile: '个人资料',
      language: '语言',
      selectLanguage: '选择语言',
      languageDescription: '选择您偏好的界面语言',
      notifications: '通知',
      security: '安全',
      preferences: '偏好设置',
      appearance: '外观',
      darkMode: '深色模式',
      timezone: '时区',
      dateFormat: '日期格式',
      saveChanges: '保存更改',
      changesSaved: '更改已成功保存',
    },
    
    auth: {
      login: '登录',
      logout: '退出',
      register: '注册',
      email: '邮箱',
      password: '密码',
      confirmPassword: '确认密码',
      forgotPassword: '忘记密码？',
      rememberMe: '记住我',
      signInWith: '使用以下方式登录',
      dontHaveAccount: '没有账号？',
      alreadyHaveAccount: '已有账号？',
      signUp: '注册',
      signIn: '登录',
    },
    
    deals: {
      title: '交易',
      pipeline: '销售管道',
      createDeal: '创建交易',
      dealValue: '交易金额',
      expectedClose: '预计成交',
      probability: '概率',
      stage: '阶段',
      won: '赢单',
      lost: '输单',
      open: '进行中',
      analytics: '交易分析',
      forecast: '预测',
    },
    
    tasks: {
      title: '任务',
      createTask: '创建任务',
      dueDate: '截止日期',
      priority: '优先级',
      status: '状态',
      assignedTo: '分配给',
      completed: '已完成',
      pending: '待处理',
      overdue: '已逾期',
      upcoming: '即将到期',
    },
    
    meetings: {
      title: '会议',
      scheduleMeeting: '安排会议',
      startTime: '开始时间',
      endTime: '结束时间',
      attendees: '参与者',
      location: '地点',
      agenda: '议程',
      scheduled: '已安排',
      cancelled: '已取消',
      completed: '已完成',
    },
    
    time: {
      today: '今天',
      yesterday: '昨天',
      tomorrow: '明天',
      thisWeek: '本周',
      thisMonth: '本月',
      thisYear: '今年',
      ago: '前',
      minutes: '分钟',
      hours: '小时',
      days: '天',
      weeks: '周',
      months: '个月',
    },
  },
};

export const supportedLanguages = Object.keys(translations).map(code => ({
  code,
  name: translations[code].name,
  dir: translations[code].dir,
}));

export default translations;
